'use strict';

module Patersons {

    export interface FooterScope extends ng.IScope {
        events: any;
        isLoggedIn: boolean;
        profile: Patersons.UserProfile;
        userCompany: UserCompany;
        freezeWindow: Patersons.FreezeWindow;
    }

    export class FooterCtrl {
        scope: FooterScope;
        sessionService: Patersons.SessionService;
        reportService: Patersons.ReportService;
        userCompanyService: Patersons.UserCompanyService;
        static $inject = ['$scope', 'sessionService', 'userCompanyService', 'reportService'];

        constructor($scope, sessionService, userCompanyService, reportService) {
            this.scope = $scope;
            this.userCompanyService = userCompanyService;
            this.sessionService = sessionService;
            this.reportService = reportService;

            this.scope.events = this;
            this.scope.isLoggedIn = this.sessionService.isLoggedIn();
            if (this.scope.isLoggedIn) {
                this.scope.profile = this.sessionService.getCurrentUserProfile();
                this.checkFreezeWindow();
                this.userCompanyService.getUserCompany().then((company) => {
                    this.scope.userCompany = company;
                })
            }
        }

        checkFreezeWindow(){
            this.reportService.checkFreezeWindow().then((freezeWindow) => {
                this.scope.freezeWindow = freezeWindow;
            });
        }

        login() {
            this.sessionService.login();
        }

        logout() {
            this.sessionService.logout();
        }
    }
}
